module.exports = __webpack_public_path__ + "media/images/services/02-5b23428d046ad7d18c695e384575ad0f.jpg";